const initialState = {
  family: [],
  name:[], 
  
  

};

const PatientFamilyReducers = (state = initialState, action: any) => {
  switch (action.type) {
      case 'FETCH_DATA1_SUCCESS':
          return {... state, family:action.payload};
          case 'FETCH_DATA2_SUCCESS':
          return {... state, name:action.payload};
          
          
          
          
         
          
         
        


    default:
      return state;
  }
};

export default PatientFamilyReducers;

